function hasOwnProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
function isEmptyObject(param) {
    return isObject(param) && !Object.keys(param).length;
}
function isObject(param) {
    return param != null && typeof param === 'object';
}
export function diff(obj1, obj2) {
    if (obj1 === obj2)
        return {};
    if (!isObject(obj1) || !isObject(obj2)) {
        return obj2;
    }
    const deletedValues = Object.keys(obj1).reduce((acc, key) => (Object.assign(Object.assign({}, acc), (!hasOwnProperty(obj2, key) && {
        [key]: undefined,
    }))), {});
    return Object.keys(obj2).reduce((acc, key) => {
        if (!hasOwnProperty(obj1, key)) {
            acc[key] = obj2[key];
            return acc;
        }
        const difference = diff(obj1[key], obj2[key]);
        if (isEmptyObject(difference) &&
            (isEmptyObject(obj1[key]) || !isEmptyObject(obj2[key])))
            return acc;
        acc[key] = difference;
        return acc;
    }, deletedValues);
}
